module.exports = __webpack_public_path__ + "img/consent-collection-widget-inline.c54e536f.svg";